import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
  FiUsers,
  FiCalendar,
  FiMic,
  FiBook,
  FiHeart,
  FiSmartphone,
  FiStar,
  FiMessageCircle,
  FiMail,
  FiMapPin,
  FiGlobe,
  FiMusic,
  FiVideo,
} from 'react-icons/fi';

// Icon mapping - converts string icon names to React components
const iconMap = {
  FiUsers,
  FiCalendar,
  FiMic,
  FiBook,
  FiHeart,
  FiSmartphone,
  FiStar,
  FiMessageCircle,
  FiMail,
  FiMapPin,
  FiGlobe,
  FiMusic,
  FiVideo,
};

// Default connect options
const defaultConnectOptions = [
  {
    id: 1,
    icon: 'FiUsers',
    title: 'Small Groups',
    description: 'Join a family or smaller group for fellowship and discipleship',
    link: '/small-groups',
  },
  {
    id: 2,
    icon: 'FiCalendar',
    title: 'Events',
    description: 'View our calendar of church activities and special gatherings',
    link: '/events',
  },
  {
    id: 3,
    icon: 'FiMic',
    title: 'CGS Podcast',
    description: 'Listen to "Dear Church Gathered & Scattered" every Monday',
    link: '/podcast',
  },
];

export default function ConnectSection({ connectCards }) {
  // Use database data if available, otherwise fallback to defaults
  const cards = connectCards && connectCards.length > 0 ? connectCards : defaultConnectOptions;

  return (
    <section className="section bg-white">
      <div className="container-wide">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="section-title"
        >
          Ways to Connect
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {cards.map((card, index) => {
            // Get the icon component from the mapping
            const IconComponent = iconMap[card.icon] || FiStar;

            return (
              <motion.div
                key={card.id || index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Link
                  to={card.link}
                  className="group block p-8 rounded-lg border border-gray-100 hover:border-accent hover:shadow-lg transition-all duration-300 text-center"
                >
                  <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-highlight flex items-center justify-center group-hover:bg-accent/20 transition-colors">
                    <IconComponent className="w-7 h-7 text-primary" />
                  </div>

                  <h3 className="text-xl font-semibold text-primary mb-3 group-hover:text-accent transition-colors">
                    {card.title}
                  </h3>

                  <p className="text-gray-600">{card.description}</p>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
